var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"useleeWidget-overflow-hidden",staticStyle:{"border-radius":"13px"},attrs:{"id":"uselee-widget","widget":"ListWA","authkey":_vm.$api.uselee,"meta":`{"User":${this.$api.user.id}}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }